import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/site/Hero";
import BestsellerStrip from "../components/site/BestsellerStrip";
import Values from "../components/site/Values";
import Marquee from "../components/site/Marquee";
import Collection from "../components/site/Collection";
import Manifesto from "../components/site/Manifesto";
import Stats from "../components/site/Stats";
import Reviews from "../components/site/Reviews";
import Contact from "../components/site/Contact";
import { scrollToId } from "../components/site/Nav";

export default function Home() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const c = params.get("c");
  const initialCategory = c === "everyday" ? "everyday" : c === "bloom" ? "bloom" : "onam";

  useEffect(() => {
    const section = location.state?.section;
    if (section) {
      const t = setTimeout(() => scrollToId(section), 300);
      return () => clearTimeout(t);
    }
    if (c) {
      const t = setTimeout(() => scrollToId("collection"), 300);
      return () => clearTimeout(t);
    }
  }, [location.state, c]);

  return (
    <>
      <Hero />
      <BestsellerStrip />
      <Values />
      <Marquee />
      <Collection initialCategory={initialCategory} />
      <Manifesto />
      <Stats />
      <Reviews />
      <Contact />
    </>
  );
}
